import { useContext, useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth';
import logoDefault from '../../assets/images/default/logo_beepay.png';
import logoGlobal from '../../assets/images/global/logo_white.svg';
import logoLafise from '../../assets/images/lafise/logo_lafise.svg';
import logoBNCR from '../../assets/images/bncr/logo_bncr.svg';

export const Navbar = () => {
    const { user, logout, resources } = useContext(AuthContext);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        const company = process.env.REACT_APP_COMPANY;
        let url;

        switch (company) {
            case 'global':
                url = logoGlobal;
                break;
            case 'lafise':
                url = logoLafise;
                break;
            case 'bncr':
                url = logoBNCR;
                break;
            default:
                url = logoDefault;
                break;
        }

        setLogoUrl(url);
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/login', { replace: true });
    };

    // Recursos padres
    const parentResources = resources
        .filter(r => r.parent_resource_id === null)
        .sort((a, b) => a.order - b.order);

    // Recursos hijos
    const childResourcesMap = resources
        .filter(r => r.parent_resource_id !== null)
        .reduce((acc: any, r) => {
            if (!acc[r.parent_resource_id]) acc[r.parent_resource_id] = [];
            acc[r.parent_resource_id].push(r);
            return acc;
        }, {});

    Object.keys(childResourcesMap).forEach(parent_resource_id => {
        childResourcesMap[parent_resource_id].sort((a, b) => a.order - b.order);
    });

    return (
        <nav
            className="navbar navbar-expand-lg navbar-dark bg-dark"
            style={{ backgroundColor: 'var(--primary-color)' }}
        >
            {/* LOGO */}
            <Link className="navbar-brand" to="/">
                <img src={logoUrl || ''} alt="Logo" className="logoNavBar" />
            </Link>

            {/* BOTÓN HAMBURGUESA */}
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarContent"
                aria-controls="navbarContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon"></span>
            </button>

            {/* CONTENIDO COLAPSABLE */}
            <div className="collapse navbar-collapse" id="navbarContent">
                {/* MENÚ IZQUIERDO */}
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                    {parentResources.map(parent => {
                        const children = childResourcesMap[parent.resource_id] || [];

                        return children.length > 0 ? (
                            <li key={parent.resource_id} className="nav-item dropdown ps-3 ps-lg-0">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                >
                                    {parent.resource_name}
                                </a>
                                <ul className="dropdown-menu">
                                    {children.map(child => (
                                        <li key={child.resource_id}>
                                            <NavLink className="dropdown-item" to={`/${child.resource_code}`}>
                                                {child.resource_name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ) : (
                            <li key={parent.resource_id} className="nav-item ps-3 ps-lg-0">
                                <NavLink className="nav-link" to={`/${parent.resource_code}`}>
                                    {parent.resource_name}
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>

                {/* MENÚ DERECHO */}
                <ul className="navbar-nav ms-auto">
                    {/* SOLO DESKTOP */}
                    <li className="nav-item d-none d-lg-block">
                        <span className="nav-link">Bienvenido, {user?.name}</span>
                    </li>

                    <li className="nav-item ps-3 ps-lg-0">
                        <button className="btn btn-link nav-link" onClick={handleLogout}>
                            Salir
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};
